import React, { useEffect, useState } from 'react';
import { XCircle } from 'lucide-react';

const SessionExpiredNotification: React.FC = () => {
  const [show, setShow] = useState(false);
  const [message, setMessage] = useState('');

  useEffect(() => {
    // Verificar si hay que mostrar notificación de sesión expirada
    const shouldShow = sessionStorage.getItem('show_session_expired_notification');
    
    if (shouldShow === 'true') {
      setShow(true);
      setMessage('Tu sesión ha expirado. La página se ha recargado automáticamente.');
      sessionStorage.removeItem('show_session_expired_notification');
      
      // Scroll al inicio
      window.scrollTo({ top: 0, behavior: 'smooth' });
      
      // Auto-ocultar después de 6 segundos
      setTimeout(() => {
        setShow(false);
      }, 6000);
    }
  }, []);

  if (!show) return null;

  return (
    <div className="fixed top-4 left-1/2 transform -translate-x-1/2 z-[9999] animate-fade-in">
      <div className="bg-white border-2 border-[#B4897F] px-6 py-4 rounded-lg shadow-2xl max-w-md">
        <div className="flex items-start space-x-3">
          <div className="flex-shrink-0">
            <div className="w-10 h-10 bg-[#B4897F]/10 rounded-full flex items-center justify-center">
              <XCircle className="w-6 h-6 text-[#B4897F]" />
            </div>
          </div>
          <div className="flex-1">
            <h3 className="font-bold text-lg mb-1 text-gray-900">Sesión Expirada</h3>
            <p className="text-sm text-gray-600">{message}</p>
          </div>
          <button
            onClick={() => setShow(false)}
            className="flex-shrink-0 text-gray-400 hover:text-gray-600 transition-colors"
          >
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
      </div>
    </div>
  );
};

export default SessionExpiredNotification;
